import { HashRouter, Route, Routes } from 'react-router-dom'

import { Home } from './pages/Home'
import { RyoikiPage } from './pages/RyoikiPage'

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path=":ryoiki" element={<RyoikiPage />}>
          <Route path=":nenji" element={<RyoikiPage />} />
        </Route>
        {/* <Route path=":ryoiki/:nenji" element={<RyoikiPage />} /> */}
      </Routes>
    </HashRouter>
  )
}

export default App
